import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _d55be86a = () => interopDefault(import('../pages/4pps.vue' /* webpackChunkName: "pages/4pps" */))
const _0376828c = () => interopDefault(import('../pages/agndr.vue' /* webpackChunkName: "pages/agndr" */))
const _0f13b8ed = () => interopDefault(import('../pages/dokumenty/index.vue' /* webpackChunkName: "pages/dokumenty/index" */))
const _30b60e83 = () => interopDefault(import('../pages/dostavka.vue' /* webpackChunkName: "pages/dostavka" */))
const _a90acd8c = () => interopDefault(import('../pages/faq.vue' /* webpackChunkName: "pages/faq" */))
const _196c884a = () => interopDefault(import('../pages/garderob/index.vue' /* webpackChunkName: "pages/garderob/index" */))
const _2f0d5331 = () => interopDefault(import('../pages/gift-card.vue' /* webpackChunkName: "pages/gift-card" */))
const _37b48db0 = () => interopDefault(import('../pages/karta-saita.vue' /* webpackChunkName: "pages/karta-saita" */))
const _6beba465 = () => interopDefault(import('../pages/kontakty.vue' /* webpackChunkName: "pages/kontakty" */))
const _5d83c2ce = () => interopDefault(import('../pages/lk/index.vue' /* webpackChunkName: "pages/lk/index" */))
const _62c11dd2 = () => interopDefault(import('../pages/lookbook/index.vue' /* webpackChunkName: "pages/lookbook/index" */))
const _2c8e8b38 = () => interopDefault(import('../pages/loyalty-program/index.vue' /* webpackChunkName: "pages/loyalty-program/index" */))
const _58aaab34 = () => interopDefault(import('../pages/magaziny.vue' /* webpackChunkName: "pages/magaziny" */))
const _803cdb8a = () => interopDefault(import('../pages/manifest.vue' /* webpackChunkName: "pages/manifest" */))
const _a9910c96 = () => interopDefault(import('../pages/midseason-sale.vue' /* webpackChunkName: "pages/midseason-sale" */))
const _458670f2 = () => interopDefault(import('../pages/offline.vue' /* webpackChunkName: "pages/offline" */))
const _6906155f = () => interopDefault(import('../pages/online.vue' /* webpackChunkName: "pages/online" */))
const _42e2222a = () => interopDefault(import('../pages/payment.vue' /* webpackChunkName: "pages/payment" */))
const _9eb601de = () => interopDefault(import('../pages/piercing.vue' /* webpackChunkName: "pages/piercing" */))
const _93c54b6c = () => interopDefault(import('../pages/pomosh-klientam.vue' /* webpackChunkName: "pages/pomosh-klientam" */))
const _690bbfb3 = () => interopDefault(import('../pages/promo.vue' /* webpackChunkName: "pages/promo" */))
const _55be3770 = () => interopDefault(import('../pages/rezultaty-poiska.vue' /* webpackChunkName: "pages/rezultaty-poiska" */))
const _0b0b4460 = () => interopDefault(import('../pages/sale-subscribe.vue' /* webpackChunkName: "pages/sale-subscribe" */))
const _c41476a2 = () => interopDefault(import('../pages/stress-test.vue' /* webpackChunkName: "pages/stress-test" */))
const _7ef4a04e = () => interopDefault(import('../pages/symbios/index.vue' /* webpackChunkName: "pages/symbios/index" */))
const _37ad8593 = () => interopDefault(import('../pages/symbios-subscribe.vue' /* webpackChunkName: "pages/symbios-subscribe" */))
const _692bcd66 = () => interopDefault(import('../pages/uspeh-oformleniya-zakaza.vue' /* webpackChunkName: "pages/uspeh-oformleniya-zakaza" */))
const _c5a86a80 = () => interopDefault(import('../pages/vacancies/index.vue' /* webpackChunkName: "pages/vacancies/index" */))
const _1e18f118 = () => interopDefault(import('../pages/vozvrat.vue' /* webpackChunkName: "pages/vozvrat" */))
const _664c0901 = () => interopDefault(import('../pages/zakaz.vue' /* webpackChunkName: "pages/zakaz" */))
const _81ae68c6 = () => interopDefault(import('../pages/zakaz-login.vue' /* webpackChunkName: "pages/zakaz-login" */))
const _143e926c = () => interopDefault(import('../pages/lk/activation.vue' /* webpackChunkName: "pages/lk/activation" */))
const _ed5748c4 = () => interopDefault(import('../pages/lk/addresses.vue' /* webpackChunkName: "pages/lk/addresses" */))
const _639ae7d3 = () => interopDefault(import('../pages/lk/favorites.vue' /* webpackChunkName: "pages/lk/favorites" */))
const _65e8593c = () => interopDefault(import('../pages/lk/info.vue' /* webpackChunkName: "pages/lk/info" */))
const _272b65e5 = () => interopDefault(import('../pages/lk/login.vue' /* webpackChunkName: "pages/lk/login" */))
const _572d8719 = () => interopDefault(import('../pages/lk/orders.vue' /* webpackChunkName: "pages/lk/orders" */))
const _1ed278f8 = () => interopDefault(import('../pages/lk/pps-club.vue' /* webpackChunkName: "pages/lk/pps-club" */))
const _1f50a560 = () => interopDefault(import('../pages/lk/recover.vue' /* webpackChunkName: "pages/lk/recover" */))
const _1cd0a652 = () => interopDefault(import('../pages/lk/register.vue' /* webpackChunkName: "pages/lk/register" */))
const _064630cb = () => interopDefault(import('../pages/lk/reset.vue' /* webpackChunkName: "pages/lk/reset" */))
const _78c043e4 = () => interopDefault(import('../pages/lk/return.vue' /* webpackChunkName: "pages/lk/return" */))
const _bf13bec6 = () => interopDefault(import('../pages/lk/subscribes.vue' /* webpackChunkName: "pages/lk/subscribes" */))
const _a2335f02 = () => interopDefault(import('../pages/lk/success.vue' /* webpackChunkName: "pages/lk/success" */))
const _69159a5a = () => interopDefault(import('../pages/symbios/posts.vue' /* webpackChunkName: "pages/symbios/posts" */))
const _689b85f6 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _a6b48814 = () => interopDefault(import('../pages/lk/login-offline/_slug.vue' /* webpackChunkName: "pages/lk/login-offline/_slug" */))
const _a1bee330 = () => interopDefault(import('../pages/dokumenty/_slug/index.vue' /* webpackChunkName: "pages/dokumenty/_slug/index" */))
const _3e7092c3 = () => interopDefault(import('../pages/drops/_slug.vue' /* webpackChunkName: "pages/drops/_slug" */))
const _5d8cbc6c = () => interopDefault(import('../pages/garderob/_look/index.vue' /* webpackChunkName: "pages/garderob/_look/index" */))
const _662e6062 = () => interopDefault(import('../pages/lookbook/_slug.vue' /* webpackChunkName: "pages/lookbook/_slug" */))
const _39eda0de = () => interopDefault(import('../pages/product/_slug/index.vue' /* webpackChunkName: "pages/product/_slug/index" */))
const _6dfeb758 = () => interopDefault(import('../pages/symbios/_slug/index.vue' /* webpackChunkName: "pages/symbios/_slug/index" */))
const _a0bcf4aa = () => interopDefault(import('../pages/vacancies/_id/index.vue' /* webpackChunkName: "pages/vacancies/_id/index" */))
const _60b2178d = () => interopDefault(import('../pages/catalog/_.vue' /* webpackChunkName: "pages/catalog/_" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/4pps",
    component: _d55be86a,
    name: "4pps"
  }, {
    path: "/agndr",
    component: _0376828c,
    name: "agndr"
  }, {
    path: "/dokumenty",
    component: _0f13b8ed,
    name: "dokumenty"
  }, {
    path: "/dostavka",
    component: _30b60e83,
    name: "dostavka"
  }, {
    path: "/faq",
    component: _a90acd8c,
    name: "faq"
  }, {
    path: "/garderob",
    component: _196c884a,
    name: "garderob"
  }, {
    path: "/gift-card",
    component: _2f0d5331,
    name: "gift-card"
  }, {
    path: "/karta-saita",
    component: _37b48db0,
    name: "karta-saita"
  }, {
    path: "/kontakty",
    component: _6beba465,
    name: "kontakty"
  }, {
    path: "/lk",
    component: _5d83c2ce,
    name: "lk"
  }, {
    path: "/lookbook",
    component: _62c11dd2,
    name: "lookbook"
  }, {
    path: "/loyalty-program",
    component: _2c8e8b38,
    name: "loyalty-program"
  }, {
    path: "/magaziny",
    component: _58aaab34,
    name: "magaziny"
  }, {
    path: "/manifest",
    component: _803cdb8a,
    name: "manifest"
  }, {
    path: "/midseason-sale",
    component: _a9910c96,
    name: "midseason-sale"
  }, {
    path: "/offline",
    component: _458670f2,
    name: "offline"
  }, {
    path: "/online",
    component: _6906155f,
    name: "online"
  }, {
    path: "/payment",
    component: _42e2222a,
    name: "payment"
  }, {
    path: "/piercing",
    component: _9eb601de,
    name: "piercing"
  }, {
    path: "/pomosh-klientam",
    component: _93c54b6c,
    name: "pomosh-klientam"
  }, {
    path: "/promo",
    component: _690bbfb3,
    name: "promo"
  }, {
    path: "/rezultaty-poiska",
    component: _55be3770,
    name: "rezultaty-poiska"
  }, {
    path: "/sale-subscribe",
    component: _0b0b4460,
    name: "sale-subscribe"
  }, {
    path: "/stress-test",
    component: _c41476a2,
    name: "stress-test"
  }, {
    path: "/symbios",
    component: _7ef4a04e,
    name: "symbios"
  }, {
    path: "/symbios-subscribe",
    component: _37ad8593,
    name: "symbios-subscribe"
  }, {
    path: "/uspeh-oformleniya-zakaza",
    component: _692bcd66,
    name: "uspeh-oformleniya-zakaza"
  }, {
    path: "/vacancies",
    component: _c5a86a80,
    name: "vacancies"
  }, {
    path: "/vozvrat",
    component: _1e18f118,
    name: "vozvrat"
  }, {
    path: "/zakaz",
    component: _664c0901,
    name: "zakaz"
  }, {
    path: "/zakaz-login",
    component: _81ae68c6,
    name: "zakaz-login"
  }, {
    path: "/lk/activation",
    component: _143e926c,
    name: "lk-activation"
  }, {
    path: "/lk/addresses",
    component: _ed5748c4,
    name: "lk-addresses"
  }, {
    path: "/lk/favorites",
    component: _639ae7d3,
    name: "lk-favorites"
  }, {
    path: "/lk/info",
    component: _65e8593c,
    name: "lk-info"
  }, {
    path: "/lk/login",
    component: _272b65e5,
    name: "lk-login"
  }, {
    path: "/lk/orders",
    component: _572d8719,
    name: "lk-orders"
  }, {
    path: "/lk/pps-club",
    component: _1ed278f8,
    name: "lk-pps-club"
  }, {
    path: "/lk/recover",
    component: _1f50a560,
    name: "lk-recover"
  }, {
    path: "/lk/register",
    component: _1cd0a652,
    name: "lk-register"
  }, {
    path: "/lk/reset",
    component: _064630cb,
    name: "lk-reset"
  }, {
    path: "/lk/return",
    component: _78c043e4,
    name: "lk-return"
  }, {
    path: "/lk/subscribes",
    component: _bf13bec6,
    name: "lk-subscribes"
  }, {
    path: "/lk/success",
    component: _a2335f02,
    name: "lk-success"
  }, {
    path: "/symbios/posts",
    component: _69159a5a,
    name: "symbios-posts"
  }, {
    path: "/",
    component: _689b85f6,
    name: "index"
  }, {
    path: "/lk/login-offline/:slug?",
    component: _a6b48814,
    name: "lk-login-offline-slug"
  }, {
    path: "/dokumenty/:slug",
    component: _a1bee330,
    name: "dokumenty-slug"
  }, {
    path: "/drops/:slug?",
    component: _3e7092c3,
    name: "drops-slug"
  }, {
    path: "/garderob/:look",
    component: _5d8cbc6c,
    name: "garderob-look"
  }, {
    path: "/lookbook/:slug",
    component: _662e6062,
    name: "lookbook-slug"
  }, {
    path: "/product/:slug",
    component: _39eda0de,
    name: "product-slug"
  }, {
    path: "/symbios/:slug",
    component: _6dfeb758,
    name: "symbios-slug"
  }, {
    path: "/vacancies/:id",
    component: _a0bcf4aa,
    name: "vacancies-id"
  }, {
    path: "/catalog/*",
    component: _60b2178d,
    name: "catalog-all"
  }, {
    path: "/man/",
    component: _60b2178d,
    name: "catalog-man"
  }, {
    path: "/woman/",
    component: _60b2178d,
    name: "catalog-woman"
  }, {
    path: "/woman/giftideas/",
    component: _60b2178d,
    name: "woman-gift-ideas"
  }, {
    path: "/man/giftideas/",
    component: _60b2178d,
    name: "man-gift-ideas"
  }, {
    path: "/man/*",
    component: _60b2178d,
    name: "catalog-man-all"
  }, {
    path: "/woman/*",
    component: _60b2178d,
    name: "catalog-woman-all"
  }, {
    path: "/secret-sale/*",
    component: _60b2178d,
    name: "secret-sale"
  }, {
    path: "/drop-piercing/*",
    component: _60b2178d,
    name: "drop-piercing"
  }, {
    path: "/sale/*",
    component: _60b2178d,
    name: "open-sale"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
